import classNames from 'classnames';

import ToggleModalButton from 'components/toggle_modal_button';

import menuItem from './menu_item';

type Props = {
    modalId: string;
    dialogType: React.ComponentType<any>;
    dialogProps?: Record<string, any>;
    content?: React.ReactNode;
    ariaLabel?: string;
    className?: string;
    children?: React.ReactNode;
    sibling?: React.ReactNode;
    showUnread?: boolean;
    onClick?: () => void;
    'data-testid'?: string;
}

export const MenuItemToggleModalReduxImpl = ({modalId, dialogType, dialogProps, content, ariaLabel, children, className, sibling, showUnread, onClick, 'data-testid': dataTestId}: Props) => (
    <>
        <ToggleModalButton
            data-testid={dataTestId}
            ariaLabel={ariaLabel}
            modalId={modalId}
            dialogType={dialogType}
            dialogProps={dialogProps}
            className={classNames({
                [`${className}`]: className,
            })}
            showUnread={showUnread}
            onClick={onClick}
        >
            {content}
            {children}
        </ToggleModalButton>
        {sibling}
    </>
);

const MenuItemToggleModalRedux = menuItem(MenuItemToggleModalReduxImpl);
MenuItemToggleModalRedux.displayName = 'MenuItemToggleModalRedux';

export default MenuItemToggleModalRedux;
